/** Shared typography scale — use across all pages for consistent sizing. */
export const type = {
  eyebrow: "text-xs font-bold uppercase tracking-[0.2em]",
  breadcrumb: "text-xs font-semibold uppercase tracking-[0.2em]",
  pageTitle: "text-4xl md:text-5xl font-black tracking-tight leading-[1.1]",
  sectionTitle: "text-3xl md:text-4xl font-black tracking-tight leading-[1.1]",
  cardTitle: "text-xl font-extrabold tracking-tight leading-snug",
  subsectionTitle: "text-lg font-extrabold tracking-tight",
  lead: "text-base md:text-lg leading-relaxed",
  body: "text-base text-slate-600 leading-relaxed text-justify",
  bodySm: "text-sm text-slate-600 leading-relaxed text-justify",
  label: "text-xs font-bold uppercase tracking-wider",
  meta: "text-sm text-slate-500 font-semibold",
  caption: "text-xs font-semibold",
};

export const typeSubtitle = {
  light: "mt-4 text-base md:text-lg text-slate-300 leading-relaxed text-left [&_p]:text-left [&_p]:text-slate-300 [&_span]:text-slate-300",
  dark: "mt-4 text-base md:text-lg text-slate-600 leading-relaxed text-left [&_p]:text-left [&_p]:text-slate-600 [&_span]:text-slate-600",
};

export const typePageSubtitle =
  "mt-5 text-base md:text-lg text-slate-200 leading-relaxed text-left max-w-2xl [&_p]:text-left [&_p]:text-slate-200 [&_span]:text-slate-200";

export const typeBodyHtml =
  "text-base text-slate-600 leading-relaxed text-justify [&_p]:text-base [&_p]:text-slate-600 [&_p]:mb-4 [&_p:last-child]:mb-0 [&_p]:text-justify";

const richDescriptionCore =
  "text-base leading-relaxed [&_p]:text-base [&_p]:mb-4 [&_p:last-child]:mb-0 [&_strong]:font-bold [&_u]:underline [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:mb-1 [&_.ql-align-justify]:text-justify [&_.ql-align-center]:text-center";

export const typeRichDescription =
  `${richDescriptionCore} text-slate-700 text-justify [&_p]:text-slate-700 [&_p]:text-justify`;

export const typeRichDescriptionCenter =
  `${richDescriptionCore} text-slate-700 text-center [&_p]:text-slate-700 [&_p]:text-center [&_span]:text-slate-700`;

export const typeRichDescriptionLight =
  `${richDescriptionCore} text-slate-300 text-justify [&_p]:text-slate-300 [&_p]:text-justify [&_span]:text-slate-300`;

export const typeRichDescriptionLightCenter =
  `${richDescriptionCore} text-slate-300 text-center [&_p]:text-slate-300 [&_p]:text-center [&_span]:text-slate-300`;
